import { FC, ReactElement, useState } from "react";
import styled from "styled-components";
import BigNumber from 'bignumber.js';
import {AppState} from '@/state';
import dayjs from 'dayjs'
import Server from "utils/serviceApi";
import { getScatter } from "utils/client";
import FailMessageModal from "@/components/FailMessageModal";
import CertificationTipsModal from "@/components/CertificationTipsModal";
import FailModal from "@/components/FailModal";
import TipsModal from "@/components/TipsModal";
import LoadingModal from "@/components/LoadingModal";
import {useDispatch, useSelector} from "react-redux";
import { useTranslation } from "react-i18next";
import {getUserInfo} from "state/base/reducer";
import { sleep} from "utils/met";
import Message from "@/components/toasts/toasts";
import useInterval from "@/hooks/useInterval";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const Recover: FC = (): ReactElement => {
  const {t} = useTranslation();
  const [messageVal, setMessageVal] = useState('')
  const [isShowModal, setShowModal] = useState<boolean>(false);
  const [loadingVal, setLoadingVal] = useState('')
  const [losedAccount, setLosedAccount] = useState('')
  const [tipsVisible, setTipsVisible] = useState<boolean>(false)
  const [certificationtipsVisible, setCertificationTipsVisible] = useState<boolean>(false)
  const [failedVisible, setFailedVisible] = useState<boolean>(false)
  const [failedMessageVisible, setFailedMessageVisible] = useState<boolean>(false)
  const [intervalInitPost, setIntervalInitPost] = useState<boolean>(false)
  const [loadingStatus, setLoadingStatus] = useState<boolean>(false)
  const [initializeParams, setInitializeParams] = useState(null)
  const [failedMsg, setFailedMsg] = useState('')
  const [recordersData, setRecordersData] = useState([])
  const dispatch = useDispatch();
  const {account} = useSelector((state: AppState) => state.baseInfo)
  const {getCompareRecover,  transferFeeRecover, getTableRowsByRecovery, getRecoverRecords} = Server
    // getTableRowsRecover,
  const [delay, setDelay] = useState<number>(3000)
  useInterval(async () => {
      if (intervalInitPost) {
          const initData = await getCompareRecover(initializeParams)
          if (initData.code === 9003) {
              setIntervalInitPost(false)
              // history.push('/recover')
          } else if (initData.code === 9005) {
              setLoadingVal('')
              setIntervalInitPost(false)
              setFailedMsg(t('home.signatureFailed'))
              setFailedMessageVisible(true)
          } else if (initData && initData.data) {
              setLoadingVal('')
              setIntervalInitPost(false)
              const baseurl = 'https://sg-production-cdn.zoloz.com/page/zoloz-face-fe/index.html'
              const zolozurl = baseurl + "?clientcfg=" + encodeURIComponent(initData.data.clientCfg);
              console.log(zolozurl,'zolozurl');
              sessionStorage.setItem('recover','true')
              window.location.href = zolozurl;
          } else {
              setDelay(new BigNumber(delay).times(2).toNumber())
          }
      }
  }, delay)

  const getRecordsData = async()=>{
    setLoadingStatus(true)
    const recoverData = await getRecoverRecords({account:account.name})
    if (recoverData?.data) {
      setRecordersData(recoverData?.data)
    }
    setLoadingStatus(false)
  }

  // useEffect(()=>{
  //   const initData = async()=>{
  //     if (!account.name) {
  //       return false
  //     }

  //   }
  //   initData()
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // },[account.name])

  const getStatus = (status)=>{
    if (status === 'pending') {
      return t('recover.Verifying')
    }else if (status === 'failed') {
      return t('recover.Verification Fails')
    }else if(status === 'finished'){
      return t('recover.Asset has been recast, please check the account')
    }
  }

  const handleSubmit = async () => {
      if (!losedAccount) {
        setMessageVal(t('Please fill in the account'))
        await sleep(2000)
        setMessageVal('')
        return
      }
      const ordersData = await getTableRowsByRecovery(account.name)
      try {
          setLoadingVal(t('home.Waiting'))
          const currentTsVal = dayjs().unix();
          const scatter: any = getScatter()
          let signData = ''
          let hasPaied = ordersData?.rows.some((item)=>{
            return item.lost_account === losedAccount && item.did_certification_status === 'pending'
          })
          if (!hasPaied) {
            await transferFeeRecover(account.name, '0.20000000 AMAX', `${losedAccount}`)
          }
          const signatureString = JSON.stringify({
              account: account.name,
              checkerType:'recover',
              lastAccount:losedAccount,
              ts: currentTsVal,
          });
          signData = await scatter.getArbitrarySignature(
            account.publicKey,
              signatureString,
          );
          setInitializeParams({
            param: {
              account: account.name,
              checkerType:'recover',
              lastAccount:losedAccount,
              ts: currentTsVal,
            }, signData: signData
          })
          setIntervalInitPost(true)

      } catch (e) {
          setLoadingVal('')
          console.log(e);
          if (typeof(e) !== 'string') {
            setFailedVisible(true)
          }else{
            const {error} = JSON.parse(e)
            if (error.details[0].message.includes('[[15]]')) {
              setMessageVal(t('recover.Non DID users'))
              await sleep(2000)
              setMessageVal('')
            }else if (error.details[0].message.includes('[[1]]')) {
              setMessageVal(t('recover.registered'))
              await sleep(2000)
              setMessageVal('')
            }else{
              setMessageVal(error.details[0].message)
              await sleep(2000)
              setMessageVal('')
            }
          }

      }

  }
  const connectWallt = () => {
      dispatch(getUserInfo());
  }

  const inputFn = (e)=>{
    const value = e.target.value
    setLosedAccount(value)
  }

  const showRecords = async() => {
    if (!account.name) {
      setMessageVal(t('layout.connect'))
      await sleep(2000)
      setMessageVal('')
      return false
    }
    getRecordsData()
    setShowModal(true);
  }
  return (
    <Main>
      <CertificationBox>
        <p className="text">{t('recover.Fill in the address where the private key was lost')}</p>
        <input className="inputer" placeholder={t('recover.Usually 12 characters')} onInput={inputFn} maxLength={12} />
        {account.name ? <CertificationBtn onClick={handleSubmit}>
          <div>DID {t('home.Certification')}</div>
        </CertificationBtn> : <CertificationBtn onClick={connectWallt}>
            <div>{t('layout.connect')}</div>
        </CertificationBtn>}
        <div className="flex-row-between-center">
          <div className="cost">{t('recover.Fee')}</div>
        </div>
      </CertificationBox>
      <RecoverNotice>
        <p> {t('recover.did1')}</p>
        <p>
          {t('recover.did2')}
        </p>
        <p>
          {t('recover.did3')}
        </p>
        <p>
          {t('recover.did4')}
        </p>
      </RecoverNotice>
      <Record
        onClick={showRecords}
      >
        {t('recover.Records')}
      </Record>
      <ModalFromBot>
        <div
          className={isShowModal ? "overlay z-show" : "overlay"}
          onClick={() => setShowModal(false)}
        ></div>
        <div className={isShowModal ? "modal z-up" : "modal"}>
          <div className="header">
            <span>{t('recover.Account records')}</span>
            <img
              className="close-btn"
              src={require("img/popup_close_icon.png").default}
              alt=""
              onClick={() => setShowModal(false)}
            />
          </div>
          <div style={{textAlign:"center"}}>
            <Spin indicator={antIcon} spinning={loadingStatus} />
          </div>
          <div className="record-list">
            {
              recordersData.map((item,index)=>{
                return (
                  <div className="record-list-item" key={index}>
                    <div className="left">{item.account}</div>
                    <div className="right s-purple">{getStatus(item.status)}</div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </ModalFromBot>
      {messageVal && <Message content={messageVal}/>}
      {loadingVal && <LoadingModal content={loadingVal}/>}
      {tipsVisible && <TipsModal onClose={() => setTipsVisible(false)}/>}
      {failedVisible && <FailModal onClose={() => setFailedVisible(false)}/>}
      {failedMessageVisible && <FailMessageModal msg={failedMsg} onClose={() => setFailedMessageVisible(false)}/>}
      {certificationtipsVisible && <CertificationTipsModal onClose={() => setCertificationTipsVisible(false)}/>}
    </Main>
  );
};

const Main = styled.div`
  padding: 0.81rem 0.16rem 0.65rem 0.16rem;
`;

const CertificationBox = styled.div`
  width: 100%;
  padding: 0.16rem;
  background: #ffffff;
  box-shadow: 0rem 0.04rem 0.12rem 0rem rgba(37, 97, 244, 0.1);
  border-radius: 0.16rem;
  font-size: 0.14rem;
  margin: 0 auto;
  .text {
    color: #333;
    font-weight: bold;
  }
  .inputer {
    width: 100%;
    height: 0.44rem;
    background: #f7f7f7;
    border-radius: 0.22rem;
    margin-top: 0.12rem;
    border: none;
    padding: 0.12rem 0.16rem;
    font-size: 0.14rem;
    color: #000;
  }
  .flex-row-between-center{
    display:flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.1rem;
    font-size:0.12rem;
    color:#d98000;
  }
  .cost {
    color: #d98000;
    font-size: 0.12rem;
  }
`;

const CertificationBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.44rem;
  background: linear-gradient(135deg, #49adff 0%, #1deece 100%);
  box-shadow: . 0rem 0.04rem 0.1rem 0rem rgba(67, 178, 203, 0.2);
  border-radius: 0.22rem;
  margin-top: 0.14rem;
  div {
    width: 96%;
    height: 0.32rem;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.24) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    box-shadow: 0rem 0.04rem 0.1rem 0rem rgba(67, 178, 203, 0.2);
    border-radius: 0.22rem;
    text-align: center;
    line-height: 0.32rem;
    color: #fff;
    font-size: 0.16rem;
  }
`;

const RecoverNotice = styled.div`
  width: 100%;
  padding: 0.12rem;
  margin: 0 auto;
  background: rgba(231, 252, 255, 0.43);
  border-radius: 0.16rem;
  border: 0.01rem solid #90fbff;
  margin-top: 0.24rem;
  white-space: pre-line;
  font-size: 0.13rem;
  color: #666666;
  line-height: 0.24rem;
`;

const Record = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  color: #0093db;
  font-size: 0.12rem;
  width: 100%;
  height: 0.6rem;
  text-align: center;
  line-height: 0.6rem;
  background-color: #fff;
  box-shadow:0 0.13rem 0.1rem 0.1rem #eee;
  z-index:12;
`;

const ModalFromBot = styled.div`
  position: relative;
  .overlay {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 201;
    background: rgba(22, 22, 22, 0.8);
    display: none;
    &.z-show {
      display: block;
    }
  }
  .modal {
    width: 100%;
    position: fixed;
    z-index: 300;
    bottom: -100%;
    left: 0;
    right: 0;
    height: 100%;
    max-height: 80%;
    min-height: 30%;
    background: #fff;
    border-radius: 0.16rem 0.16rem 0rem 0rem;
    transition: all 0.5s;
    .header {
      position: relative;
      height: 0.54rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.16rem;
      color: #161617;
      font-weight: bold;
      .close-btn {
        position: absolute;
        right: 0.16rem;
        top: 50%;
        transform: translateY(-50%);
        width: 0.22rem;
      }
    }
    .record-list {
      height: calc(100% - 0.54rem);
      overflow-y: scroll;
      &-item {
        padding: 0 0.32rem;
        height: 0.44rem;
        background: #f7f7f7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.14rem;
        color: #333;
        .left {
          color: #666;
        }
        .right {
          font-size: 0.12rem;
          text-align:right;
          &.s-blue {
            color: #0093db;
          }
          &.s-purple {
            color: #08bdc7;
          }
          &.s-red {
            color: #ff3456;
          }
        }
        &:nth-child(2n) {
          background: #fff;
        }
      }
    }
    &.z-up {
      bottom: 0;
    }
  }
`;



export default Recover;
